import configJson from "./auth_config.json";

export function getConfig(selectedDomainIndex = 0) {
  // Validate that domains exist and is an array
  if (!configJson.domains || !Array.isArray(configJson.domains) || configJson.domains.length === 0) {
    throw new Error("No domains found in auth_config.json or domains is not an array");
  }

  // Select the domain based on the provided index (default to 0)
  const domain = configJson.domains[selectedDomainIndex];
  if (!domain) {
    throw new Error(`Invalid domain index: ${selectedDomainIndex}. Available domains: ${configJson.domains.join(", ")}`);
  }

  // Configure the audience
  const defaultAudience = configJson.audience && configJson.audience !== "YOUR_API_IDENTIFIER"
    ? configJson.audience
    : null;
  const managementApiAudience = configJson.managementApiAudience.replace("{domain}", domain);

  const organization = configJson.organization || null;
  const connection = configJson.connection || null;
  const invitation = configJson.invitation || null;
  const additionalParams = configJson.additionalParams || null;
  const scopes = configJson.scope || null;

  return {
    domain,
    clientId: configJson.clientId,
    ...(defaultAudience ? { audience: defaultAudience } : null), // Default audience for "Secure Your API"
    managementApiAudience, // Management API audience for linking
    ...(organization ? { organization } : {}),
    ...(connection ? { connection } : {}),
    ...(invitation ? { invitation } : {}),
    ...(additionalParams ? { additionalParams } : {}),
    ...(scopes ? { scope: scopes } : {})
  };
}